module.exports = __webpack_public_path__ + "static/DIYProjects-c73e79e204afe3bcbe0960ad475bf48c.png";